






































import Vue from 'vue';
// import contact, { Contact } from '@/modules/contact/contact';
// import contact, { Contact } from '@/modules/contact/contact';

import {
  Entry,
  entry as entryM,
  PublicBuyer,
  publicBuyer as buyerM,
  PublicBuyerCompany,
  publicBuyerCompany as buyerCompanyM,
  PublicExhibition,
  publicExhibition as exhibitionM,
  PublicOffline,
  PublicOfflineDay,

  PublicExhibitor,
  PublicExhibitorCompany,
  publicExhibitorCompany as exhibitorCompanyM,
  publicExhibitor as exhibitorM,
} from 'mostra';

type EntryInfo = {
  entry: Entry;
  buyer: PublicBuyer;
  buyerCompany: PublicBuyerCompany;
  exhibition: PublicExhibition;
  exhibitor: PublicExhibitor;
  exhibitorCompany: PublicExhibitorCompany;
  offline: PublicOffline;
  offlineDay: PublicOfflineDay;
};

interface DataType {
  entries: EntryInfo[];
  // contacts: Contact[] | null;
  emptyText: string;
}

export default Vue.extend({
  name: 'buyer-vis-list',
  data(): DataType {
    return {
      entries: [],
      emptyText: `予約展示会はありません。
      展示会に入場してみましょう`,
    };
  },
  methods: {
    async fetchContact() {
      try {
        this.$loading(true);
        const entries: EntryInfo[] = [];
        const ens = await entryM.loadsByBuyerId(this.$auth.uid);
        for (const en of ens) {
          if (!en.data.isReservation) {
            continue;
          }

          if (!en.data.buyer.uid || !en.data.exhibition.exhibitionId) {
            throw new Error('buyer is not found');
          }

          const buyer = await buyerM.load(en.data.buyer.uid);
          if (!buyer || !buyer.data.cid) {
            throw new Error('buyer is not found');
          }

          const buyerCompany = await buyerCompanyM.load(buyer.data.cid);
          if (!buyerCompany) {
            throw new Error('buyerCompany is not found');
          }

          const exhibition = await exhibitionM.load(en.data.exhibition.exhibitionId);
          if (!exhibition) {
            throw new Error('exhibition is not found');
          }

          const offline = exhibition.data.offlines.find((o) => o.id === en.data.exhibition.offlineId);
          if (!offline) {
            throw new Error('offline is not found');
          }

          const offlineDay = offline.days.find((d) => d.id === en.data.exhibition.dayId);
          if (!offlineDay) {
            throw new Error('offlineDay is not found');
          }
          const exhibitorCompany = await exhibitorCompanyM.load(exhibition.data.owner);
          if (!exhibitorCompany) {
            throw new Error('exhibitorCompany is null');
          }

          const exhibitor = await exhibitorM.load(exhibition.data.staff);
          if (!exhibitor) {
            throw new Error('exhibitor is null');
          }
          entries.push({
            entry: en,
            buyer,
            buyerCompany,
            exhibition,
            offline,
            offlineDay,
            exhibitor,
            exhibitorCompany,
          });
        }

        this.entries = entries.sort((a, b) => (a.offlineDay.date > b.offlineDay.date ? 1 : -1));
      } catch (err: any) {
        this.$fatal(err);
      } finally {
        this.$loading(false);
      }
    },
    toTopPage() {
      window.location.href = '/ssr/';
    },
    onClickListItem(id: string) {
      window.location.href = `/ssr/vis/${id}`;
      // this.$router.push({ name: 'buyer-contact-chat', params: { id } });
    },
  },
  async mounted() {
    await this.fetchContact();
  },
});
